// extracted by mini-css-extract-plugin
export var boxItems = "_7x-1";
export var boxItemsLg = "_7x-2";
export var button = "_7x-7";
export var buttonLg = "_7x-8";
export var filterGroupBox = "_7x-0";
export var icon = "_7x-3";
export var iconSecondary = "_7x-6";
export var iconWrapper = "_7x-4";
export var iconWrapperLg = "_7x-5";